// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const alloFormatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'RstAllo',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;

      let color;

      switch (item.RstAllo) {
        case 'Y':
          color = 'orange';
          break;
        default:
          color = '';
          break;
      }

      wjcCore.addClass(elem.cell, color);
    },
  });

export default alloFormatter;
